import type { FamilyUserResponse } from 'we-tree-api-client/v2';

/** Alias for overview user lists; email is present only per API visibility rules. */
export type FamilyUserSummary = FamilyUserResponse;

export function getFamilyUserDisplayName(user: FamilyUserSummary): string {
  return user.nickname?.trim() || user.memberName?.trim() || '—';
}

/** Secondary line: member name (when distinct) and email for owner/admin roles only. */
export function getFamilyUserSecondaryLine(user: FamilyUserSummary, showEmail: boolean): string | null {
  const parts: string[] = [];
  const nickname = user.nickname?.trim();
  const memberName = user.memberName?.trim();

  if (memberName && memberName !== nickname) {
    parts.push(memberName);
  }

  if (showEmail && (user.role === 'owner' || user.role === 'admin')) {
    const email = user.email?.trim();
    if (email) {
      parts.push(email);
    }
  }

  return parts.length > 0 ? parts.join(' · ') : null;
}
